(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('PeriodeSearch', PeriodeSearch);

    PeriodeSearch.$inject = ['$resource'];

    function PeriodeSearch($resource) {
        var resourceUrl =  'api/_search/periodes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
